/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class SectionTab extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    isSticky: PropTypes.bool,
    loading: PropTypes.bool,
    onTabChange: PropTypes.func,
    tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
    tabID: PropTypes.number,
    t: PropTypes.func,
  }
  static defaultProps = {
    isMobile: false,
    tabID: 1,
  }
  static getPropsToState = (props) => {
    const bookingID = props.bookingID || '';
    const isSticky = props.isSticky;
    const loading = props.loading;
    const tabs = props.tabs || [];
    const tabID = props.tabID;
    return {
      bookingID,
      isSticky,
      loading,
      tabs,
      tabID,
    };
  }
  constructor(props) {
    super(props);
    const state = SectionTab.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SectionTab.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleTabClick = (e, tab) => {
    const { isSticky } = this.state;
    e.preventDefault();
    this.setState({ tabID: tab.id }, () => {
      if (this.props.onTabChange) {
        this.props.onTabChange({
          ...tab,
          isSticky,
        });
      }
    });
  }
  render() {
    const { isMobile, t } = this.props;
    const { isSticky, loading, tabs, tabID } = this.state;
    const filteredTabs = tabs.filter(tab => !tab.disabled);
    const renderRedDot = (tab) => tab.showDot && (
      <span className="show-dot" />
    );
    return (
      <div>
        {isSticky ?
          <Button.Group className="uc-section-tabs sticky" compact fluid size={isMobile ? 'mini' : 'tiny'} disabled={loading}>
            {
              filteredTabs.map((tab, idx) => (
                <Button key={idx} active={tabID === tab.id} onClick={e => this.handleTabClick(e, tab)} disabled={tab.isLocked} style={isMobile ? { fontSize: '0.65rem' } : {}}>
                  {t(tab.title).toUpperCase()}
                  {renderRedDot(tab)}
                </Button>
              ))
            }
          </Button.Group>
          :
          (isMobile ?
            <Button.Group className="uc-section-tabs" compact fluid size="mini" disabled={loading}>
              {
                filteredTabs.map((tab, idx) => (
                  <Button key={idx} active={tabID === tab.id} disabled={tab.isLocked} onClick={e => this.handleTabClick(e, tab)}>
                    {t(tab.title).toUpperCase()}
                    {renderRedDot(tab)}
                  </Button>
                ))
              }
            </Button.Group>
            :
            <Button.Group className="uc-section-tabs" fluid disabled={loading}>
              {
                filteredTabs.map((tab, idx) => (
                  <Button key={idx} active={tabID === tab.id} disabled={tab.isLocked} onClick={e => this.handleTabClick(e, tab)}>
                    <Header as="h5" inverted={tabID === tab.id}>
                      {t(tab.title).toUpperCase()}
                      {renderRedDot(tab)}
                    </Header>
                  </Button>
                ))
              }
            </Button.Group>
          )
        }
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens, { withRef: true })(SectionTab);



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCSectionTab.jsx